import { REDACTION_MARKER, REDACTION_MARKER_VIEWER } from '../../common/constants.tsx';

type Field = {
	fieldId?: string | null;
	typeKey?: string | null;
};

export const getTargetField = (fields: Field[]) => {
	const fieldMap: Record<string, Field> = {};
	fields.forEach((field) => {
		if (field.fieldId) {
			fieldMap[field.fieldId] = field;
		}
	});

	return (
		fieldMap.description?.fieldId ||
		fieldMap.environment?.fieldId ||
		fieldMap.summary?.fieldId ||
		fields.find(
			(field) => field.typeKey === 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
		)?.fieldId ||
		fields.find(
			(field) => field.typeKey === 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
		)?.fieldId ||
		null
	);
};

export const getInitialSpotlightType = (
	isEditor: Boolean,
	showViewerExp: Boolean,
	showEditorExp: Boolean,
) => {
	if (isEditor && showEditorExp) {
		return REDACTION_MARKER;
	}
	if (showViewerExp) {
		return REDACTION_MARKER_VIEWER;
	}
	return null;
};
